<div class="row">
  <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
    <div class="loyalty-grid-container px-3">
      <mat-card class="p-2">
        <div class="label-holder">
          <span class="content-label">
            <span> Pricelist Mapping </span
            ></span>
          
        </div>
        <div class="generate-promocode-form-container">
          <form
            (ngSubmit)="onLoyaltyFormSubmit()"
            [formGroup]="loyaltyRewardsForm"
          >
            <div class="form-container">
              <div class="row my-2">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.salesRepDist<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <mat-select 
                      (selectionChange)="onSelected($event)"
                      formControlName="codeGroup" 
                      required>
                        <mat-option
                          *ngFor="let codeGroup of codeGroups"
                          [value]="codeGroup"
                          >{{ codeGroup }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="f.codeGroup.touched && f.codeGroup.invalid">
                      <div *ngIf="f.codeGroup.errors.required">
                        <mat-hint class="text-danger ms-2">
                          {{ "pages.AddRetailer.DistributorRepIsRequired" | translate }}.</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row my-2">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label">
                    {{'pages.newRetailer.pricelist' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline" class="country-list">
                      <mat-select
                        [formControl]="countryControl"
                        required
                        multiple
                      >
                        <mat-option
                          #allSelected
                          (click)="toggleAllSelection()"
                          [value]="0"
                          class="first-option"
                        ></mat-option>
                        <mat-option
                          *ngFor="let item of countriesList"
                          [value]="item"
                          (click)="tosslePerOne(allSelected)"
                        >
                          {{ item }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="f.country.touched && f.country.invalid">
                      <div *ngIf="f.country.errors.required">
                        <mat-hint class="text-danger ms-2">
                          {{ 'pages.placeholders.Pricelistassignmentisrequired' | translate }}</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
             
            </div>

            <div class="form-footer">
              <ul class="list-inline text-center">
                <li class="list-inline-item">
                  <button
                    mat-raised-button
                    [disabled]="!loyaltyRewardsForm.valid"
                    color="primary"
                    type="submit"
                  >
                    <span translate class="translate">Save</span>
                  </button>
                </li>
                <li class="list-inline-item">
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="onCancel()"
                  >
                    <span translate class="translate"
                      >pages.newRetailer.cancel</span
                    >
                  </button>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </mat-card>
    </div>
  </div>
</div>
